import { render, staticRenderFns } from "./RazorPayWebIntegrationSubscription.vue?vue&type=template&id=a1955374&"
import script from "./RazorPayWebIntegrationSubscription.vue?vue&type=script&lang=js&"
export * from "./RazorPayWebIntegrationSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports